import { Button, TextField } from '@mui/material';
import { DocumentStatus } from '@synergy/models';
import {
    PaloDetailView,
    PaloField,
    PaloFormGrid,
    PaloFormSection,
    PaloPositionSum,
    PaloReadValue,
    PaloStatusPill,
} from '@synergy/components-palo';
import { ReactElement } from 'react';

/**
 * Temporary reference screen validating the PALO detail/form foundation
 * against Christian's prototype. Not linked in the nav; remove before merge.
 */
export const PaloFormPreview = (): ReactElement => (
    <PaloDetailView
        onBack={() => undefined}
        number="ER-2026-04417"
        title="Rechnung"
        status={<PaloStatusPill status={DocumentStatus.Ongoing} label="In Arbeit" />}
        meta={[
            { label: 'Empfänger', value: 'Bergbahnen Sölden' },
            { label: 'Erstellt', value: '18.07.2026' },
            { label: 'Brutto', value: '3.289,44 €' },
        ]}
        actions={
            <>
                <Button variant="outlined" color="inherit" size="small">
                    Duplizieren
                </Button>
                <Button variant="contained" color="primary" size="small">
                    Speichern
                </Button>
            </>
        }
    >
        <PaloFormSection title="Stammdaten">
            <PaloFormGrid>
                <PaloField label="Bezeichnung">
                    <PaloReadValue>Sonepar Österreich GmbH</PaloReadValue>
                </PaloField>
                <PaloField label="Nummer">
                    <PaloReadValue mono>L-10428</PaloReadValue>
                </PaloField>
                <PaloField label="UID">
                    <PaloReadValue mono>ATU 38472916</PaloReadValue>
                </PaloField>
                <PaloField label="Zahlungsziel" hint="Weicht von der Kondition ab">
                    <PaloReadValue>14 Tage netto</PaloReadValue>
                </PaloField>
                <PaloField label="Währung">
                    <PaloReadValue strong>EUR</PaloReadValue>
                </PaloField>
                <PaloField label="Sachbearbeiter">
                    <PaloReadValue>Rukiye Ünal</PaloReadValue>
                </PaloField>
            </PaloFormGrid>
        </PaloFormSection>

        <PaloFormSection title="Positionen — Summenfuß">
            <PaloPositionSum
                entries={[
                    { label: 'Netto', value: '2.741,20' },
                    { label: 'USt 20 %', value: '548,24' },
                    { label: 'Brutto EUR', value: '3.289,44', total: true },
                ]}
            />
        </PaloFormSection>

        <PaloFormSection title="Bearbeiten (Formularfelder)">
            <PaloFormGrid>
                <PaloField label="Titel">
                    <TextField size="small" defaultValue="Wartung Beschneiung" fullWidth />
                </PaloField>
                <PaloField label="Betrag netto">
                    <TextField size="small" defaultValue="2.741,20" fullWidth />
                </PaloField>
                <PaloField label="Rechnungsdatum" error="Datum darf nicht in der Zukunft liegen">
                    <TextField size="small" defaultValue="30.08.2026" fullWidth error />
                </PaloField>
                <PaloField label="Notiz" span={3}>
                    <TextField
                        size="small"
                        defaultValue=""
                        placeholder="Interne Notiz …"
                        fullWidth
                        multiline
                        minRows={2}
                    />
                </PaloField>
            </PaloFormGrid>
        </PaloFormSection>
    </PaloDetailView>
);
